export default __webpack_public_path__ + "static/media/external-link.71629004.svg";